import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
  };

  return (
    <div className="language-switcher">
      <button
        onClick={() => changeLanguage('en')}
        className={`flag-btn ${i18n.language === 'en' ? 'active' : ''}`}
        title="English"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 30" width="32" height="16">
          <clipPath id="s">
            <path d="M0,0 v30 h60 v-30 z"/>
          </clipPath>
          <clipPath id="t">
            <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"/>
          </clipPath>
          <g clipPath="url(#s)">
            <path d="M0,0 v30 h60 v-30 z" fill="#012169"/>
            <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6"/>
            <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#t)" stroke="#C8102E" strokeWidth="4"/>
            <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10"/>
            <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6"/>
          </g>
        </svg>
      </button>
      <button
        onClick={() => changeLanguage('pl')}
        className={`flag-btn ${i18n.language === 'pl' ? 'active' : ''}`}
        title="Polski"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 10" width="32" height="20">
          <rect width="16" height="5" fill="#fff"/>
          <rect y="5" width="16" height="5" fill="#dc143c"/>
        </svg>
      </button>
    </div>
  );
}

export default LanguageSwitcher;
